/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 25.07.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ClassNames from 'classnames';
import {VelocityTransitionGroup} from 'velocity-react';

import Translate from '../../components/Translate';

import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import _find from 'lodash/find';

import NarLoginTab from './Tabs/_extentions/nar/nar-login';
import NarRegistrationTab from './Tabs/_extentions/nar/nar-registration';
import NarSelectLanguageTab from './Tabs/_extentions/nar/nar-select-language';

import SelectLanguageTab from './Tabs/select-language';
import ParentalControlTab from './Tabs/parental-control';
import LoginTab from './Tabs/login';
import RegistrationTab from './Tabs/registration';
import ResetPasswordTab from './Tabs/reset-password';
import RegistrationConfirmTab from './Tabs/registration-confirm';
import ChangePasswordTab from './Tabs/change-password';

import {SetSettingsState} from '../../actions/common/actions-common'

class Settings extends Component {
  constructor(props) {
    super(props);

    this.animationEnter = {
      translateY: '0px',
      opacity: 1
    };
    this.animationLeave = {
      translateY: '20px',
      opacity: 0
    };

    this.defaultTabs = [
      {
        id: 'language',
      },
    ];

    this.state = {
      currentTab: null
    };
  }

  componentDidMount() {
    this.setState({currentTab: this.props.settings.tabId});
  }

  componentWillReceiveProps(newProps) {

    if (!_isEqual(newProps.settings, this.props.settings)) {
      this.setState({currentTab: newProps.settings.tabId});
    }
  }

  setTab(tabId) {
    this.setState({currentTab: tabId});
  }

  _onSettingsClose = () => {

    this.props.SetSettingsState({
      isShown: false,
      tabId: null
    });

    this.__scrollBack();
  };

  __scrollBack = () => {
    if (!_get(this.props, 'settings.meta.fromPosition')) return;

    var doc = document.documentElement || document.body;
    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

    if (top < _get(this.props, 'settings.meta.fromPosition')) {
      document.body.scrollTop = document.documentElement.scrollTop = top + 100;
      setTimeout(this.__scrollBack, 5);
    }
  };

  _renderList() {

    return (
      <ul className="settings-tabs-links">
        {_get(Config, 'settings.tabs', this.defaultTabs)
          .filter((tab) => {
            if (this.props.user.user === 'guest') {

              return !tab.is_auth_required;
            } else {

              return tab.id !== 'login' && tab.id !== 'registration';
            }
          })
          .map((tab) => {
            let liClass = ClassNames({
              'active': tab.id === this.state.currentTab
            });

            if (!!tab.is_external) {
              return <li key={'tab_' + tab.id} id={tab.id} className={liClass}>
                <a href={tab.link} target="_blank">
                  {tab.name ?
                    tab.name
                    :
                    <Translate content={`settings.tabs.${tab.id}.title`} />
                  }
                </a>
              </li>
            }

            return (<li key={'tab_' + tab.id} id={tab.id} className={liClass} onClick={this.setTab.bind(this, tab.id)}>
              <Translate content={`settings.tabs.${tab.id}.title`} />
            </li>);
          })}
      </ul>);
  }

  _renderTabs() {
    if (_get(Config, 'operator_ext_id') === 'nar') {
      switch (this.state.currentTab) {
        case "login":
          return <NarLoginTab />;
        case "registration":
          return <NarRegistrationTab />;
        case "language":
          return <NarSelectLanguageTab />;
      }
    }

    switch (this.state.currentTab) {
      case "language":
        return <SelectLanguageTab />;
      case "parental_control":
        return <ParentalControlTab />;
      case "login":
        return <LoginTab />;
      case "registration":
        return <RegistrationTab />;
      case "reset-password":
        return <ResetPasswordTab ack={_get(this.props.settings, 'meta.ack')} />;
      case "registration-confirm":
        return <RegistrationConfirmTab ack={_get(this.props.settings, 'meta.ack')} />;
      case "change_password":
        return <ChangePasswordTab />;
      default:
        return <div style={{height: '35px'}}></div>;
    }
  }

  render() {

    return (<VelocityTransitionGroup
      enter={{animation: this.animationEnter, easing: 'ease-in-out', duration: 350}}
      leave={{animation: this.animationLeave, easing: 'ease-in-out', duration: 150}}>
      {this.props.settings.isShown ? <div className="settings bg-black radius">
        <div className="settings-content">
          <h4><Translate content="settings.settings" /></h4>
          <div className="settings-tabs clearfix">
            {this._renderList()}
            <div className="settings-tabs-block padded-tabs">
              <a className="ico-close" href="javascript:void(0)" onClick={this._onSettingsClose}> <Translate content="close" /> </a>
              {this._renderTabs()}
            </div>
          </div>
        </div>
      </div> : null }
    </VelocityTransitionGroup>);
  }
}

Settings.propTypes = {
  settings: PropTypes.object.isRequired
};

const mapStateToProps = function ({common: {settings}, auth: {user}}, ownProps) {

  return {settings, user};
};

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({SetSettingsState}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);



// WEBPACK FOOTER //
// ./src/containers/Settings/settings.js